import { PaymentsDue } from "@/components/home/PaymentsDue";
import { DashboardStats } from "@/components/home/DashboardStats";

export default function Incassi() {
  return (
    <div className="space-y-6 animate-in-up" data-testid="incassi-page">
      <PaymentsDue />
      <DashboardStats />
    </div>
  );
}
